import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const getValidationChecklist = async (communityId: string | number, fiscalYear: string | number) => {
  return await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/checklist`);
};

const useGetValidationChecklist = ({
  communityId, 
  fiscalYear,
  queryParams
}: {
  communityId?: string | number,
  fiscalYear?: string | number,
  queryParams?: any;
}) =>
  useQuery({
    queryKey: ["validation-checklist", communityId, fiscalYear],
    queryFn: () => getValidationChecklist(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    ...queryParams
  });

export default useGetValidationChecklist;